import { render, staticRenderFns } from "./operationRecordHD.vue?vue&type=template&id=036a0874&"
import script from "./operationRecordHD.vue?vue&type=script&lang=js&"
export * from "./operationRecordHD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('036a0874')) {
      api.createRecord('036a0874', component.options)
    } else {
      api.reload('036a0874', component.options)
    }
    module.hot.accept("./operationRecordHD.vue?vue&type=template&id=036a0874&", function () {
      api.rerender('036a0874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/operationRecord/operationRecordHD.vue"
export default component.exports